<script setup lang="ts">
import { Card } from "@/components/ui/card";
import PageHeader from "@/components/PageHeader.vue";
import ManageTenants from "@/components/ManageTenants/Table.vue";
// import Loading from "@/components/Loading.vue";
import { useUser } from "@/composables/useUser";
import { onMounted } from "vue";
const auth = useUser();

onMounted(async()=> {
  await auth.initialize();
})


</script>
<template>
  <div v-if="auth.is_global_admin()">
    <PageHeader title="Administration"> </PageHeader>
  </div>
  
  <Card class="p-6 rounded-3xl dark:bg-[#0d1526]">
    <ManageTenants />
  </Card>
  
</template>
